/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway-configurations.scss';

/* eslint-disable import/no-unresolved, import/default */

import gatewayConfigurationsTemplate from './gateway-configurations.tpl.html';
import gatewayConfigurationTemplate from './gateway-configuration.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.configuration.gatewayConfigurations', [])
    .directive('tkGatewayConfigurations', GatewayConfigurations)
    .name;

/*@ngInject*/
function GatewayConfigurations() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            entityId: '=',
            isReadOnly: '=',
            isGroup: '=',
            groupId: '='
        },
        controller: GatewayConfigurationsController,
        controllerAs: 'vm',
        templateUrl: gatewayConfigurationsTemplate
    };
}

/*@ngInject*/
function GatewayConfigurationsController($scope, configurationService, $filter, $document, $window, $translate, $mdMedia, types, $mdDialog, tkDialogs) {

    var vm = this;
    vm.$onInit = function () {
        vm.types = types;

        vm.addEnabled = true;

        vm.groupConfigurations = {};
        vm.allConfigurations = [];
        vm.configurations = [];
        vm.configRowsCount = 0;

        vm.query = {
            order: 'type',
            limit: 15,
            page: 1
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.reload = reload;

        vm.onConfigurationsReorder = function () {
            updateConfigurations();
        };

        vm.onConfigurationsPaginate = function () {
            updateConfigurations();
        };

        vm.scopeName = scopeName;
        vm.syncStatus = syncStatus;
        vm.editEnabled = editEnabled;

        vm.addConfiguration = addConfiguration;
        vm.editConfiguration = editConfiguration;
        vm.deleteConfiguration = deleteConfiguration;
        vm.deleteEnabled = deleteEnabled;
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.entityId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function reload() {
        vm.groupConfigurations = {};
        vm.allConfigurations.length = 0;
        vm.configurations.length = 0;
        vm.configRowsCount = 0;
        vm.addEnabled = true;
        configurationService.getEntityConfigurations(vm.entityId.entityType, vm.entityId.id).then(
            (configurations) => {
                vm.allConfigurations = configurations;
                var testTypes = Object.keys(vm.types.configurationType);
                for (var i=0;i<vm.allConfigurations.length;i++) {
                    var configurationType = vm.allConfigurations[i].type;
                    var index = testTypes.indexOf(configurationType);
                    if (index != -1) {
                        testTypes.splice(index, 1);
                    }
                }
                vm.addEnabled = testTypes.length > 0;
                if (!vm.isGroup && vm.groupId) {
                    configurationService.getEntityConfigurations(vm.groupId.entityType, vm.groupId.id).then(
                        (groupConfigurations) => {
                            for (var c=0;c<vm.allConfigurations.length;c++) {
                                var configuration = vm.allConfigurations[c];
                                if (!configuration.contentType) {
                                    configuration.useGroupConfiguration = true;
                                }
                            }
                            for (var g=0;g<groupConfigurations.length;g++) {
                                var groupConfiguration = groupConfigurations[g];
                                vm.groupConfigurations[groupConfiguration.type] = groupConfiguration;
                                var result = $filter('filter')(vm.allConfigurations, { type: groupConfiguration.type }, true);
                                if (!result || !result.length) {
                                    configuration = angular.copy(groupConfiguration);
                                    configuration.isGroupConfiguration = true;
                                    vm.allConfigurations.push(configuration);
                                } else {
                                    if (result[0].useGroupConfiguration) {
                                        result[0].updateTs = groupConfiguration.updateTs;
                                        result[0].contentType = groupConfiguration.contentType;
                                        result[0].content = groupConfiguration.content;
                                    }
                                }
                            }
                            updateConfigurations();
                        },
                        () => {
                            updateConfigurations();
                        }
                    );
                } else {
                    updateConfigurations();
                }
            },
            () => {
                updateConfigurations();
            }
        );
    }

    function updateConfigurations() {
        var result = $filter('orderBy')(vm.allConfigurations, vm.query.order);
        vm.configRowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.configurations = result.slice(startIndex, startIndex + vm.query.limit);
    }

    function scopeName(configuration) {
        if (configuration.isGroupConfiguration || configuration.useGroupConfiguration) {
            return $translate.instant(vm.types.configScope.group.name);
        } else {
            return $translate.instant(vm.types.configScope.gateway.name);
        }
    }

    function syncStatus(configuration) {
       if (configuration && configuration.contentType) {
            if (!angular.equals(configuration.contentType, configuration.remoteContentType) ||
                !angular.equals(configuration.content, configuration.remoteContent)) {
                return $translate.instant(types.configSyncStatus.notSynced.name);
            }
        }
        return $translate.instant(types.configSyncStatus.synced.name);
    }

    function addConfiguration($event) {
        openConfigurationDialog($event, null);
    }

    function editConfiguration($event, configuration) {
        openConfigurationDialog($event, configuration);
    }

    function deleteConfiguration($event, configuration) {
        var configurationType = $translate.instant(vm.types.configurationType[configuration.type].name);
        var title = $translate.instant('configuration.delete-configuration-title', {configurationType: configurationType});
        var content = $translate.instant('configuration.delete-configuration-text');
        var label = $translate.instant('configuration.delete-configuration');

        tkDialogs.confirm($event, title, content, label).then(
            () => {
                configurationService.deleteConfiguration(configuration.type,
                    configuration.entityId.entityType, configuration.entityId.id).then(
                    () => { reload(); }
                );
            }
        );
    }

    function editEnabled(configuration) {
        return !vm.isReadOnly && (!configuration || !configuration.isGroupConfiguration);
    }

    function deleteEnabled(configuration) {
        return !vm.isReadOnly && !configuration.isGroupConfiguration;
    }

    function openConfigurationDialog($event, configuration) {
        var isAdd = false;
        var readonly = !editEnabled(configuration);
        if (!readonly) {
            if (!configuration) {
                isAdd = true;
                configuration = {
                    entityId: vm.entityId
                }
            } else {
                configuration = angular.copy(configuration);
            }
        }
        var excludeConfigurationTypes = [];
        for (var i=0;i<vm.allConfigurations.length;i++) {
            if (!vm.allConfigurations[i].isGroupConfiguration && (!configuration.id || configuration.id.id != vm.allConfigurations[i].id.id)) {
                excludeConfigurationTypes.push(vm.allConfigurations[i].type);
            }
        }

        $mdDialog.show({
            controller: 'GatewayConfigurationController',
            controllerAs: 'vm',
            templateUrl: gatewayConfigurationTemplate,
            parent: angular.element($document[0].body),
            locals: {
                entityId: vm.entityId,
                configuration: configuration,
                isAdd: isAdd,
                isReadOnly: readonly,
                isGroup: vm.isGroup || configuration.isGroupConfiguration,
                showRemote: !vm.isGroup,
                groupConfigurations: vm.groupConfigurations,
                excludeConfigurationTypes: excludeConfigurationTypes
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            if (!vm.isReadOnly) {
                reload();
            }
        }, function () {
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/configuration/gateway-configurations.directive.js